<template>
  <div>
    <page-header
      :page="page"
      left-side-class="col-xl-8"
      right-side-class="col-xl-4 d-flex align-items-end justify-content-end pb-2"
    />
    <div class="container-fluid box-container pb-3 mt-1 mb-4">
      <div class="row">
        <div class="col">
          <ValidationObserver ref="form" v-slot="{ handleSubmit }">
            <div class="row p-3">
              <div
                class="col-12"
                :class="[searched ? 'col-md-5 border-divider' : 'col-md-6']"
              >
                <div class="mb-4">
                  <em
                    class="fas fa-user-plus rounded-circle shadow text-orange p-2 mr-2"
                  />
                  <span class="box-title">Añadir Estudiante</span>
                </div>
                <div class="mb-4 mb-md-0">
                  <ValidationProvider
                    ref="studentSieValidator"
                    v-slot="{ errors }"
                    rules="required|integer"
                  >
                    <CustomInput
                      v-model="studentSie"
                      :error="errors[0]"
                      placeholder="Escriba número de SIE"
                      custom-error-msg="Favor escriba número de SIE."
                    />
                  </ValidationProvider>
                </div>
              </div>
              <div
                v-if="searched"
                class="col-12 col-md ml-0 ml-md-3 mt-4 mt-md-0 mb-4 mb-md-0"
              >
                <CustomBalloon
                  :class="['mb-2', { 'w-40': !isMobile }]"
                  :text="'Resultado'"
                />
                <div v-if="student">
                  <div>
                    <span class="box-result-field-label mr-1">Nombre:</span>
                    <span class="box-result-field-value">
                      {{ student.firstName }} {{ student.lastName }}
                    </span>
                  </div>
                  <div>
                    <span class="box-result-field-label mr-1">Edad:</span>
                    <span class="box-result-field-value">{{
                      student.age
                    }}</span>
                  </div>
                  <div>
                    <span class="box-result-field-label mr-1">SIE:</span>
                    <span class="box-result-field-value">
                      {{ student.studentId }}
                    </span>
                  </div>
                  <div>
                    <span class="box-result-field-label mr-1">Registro:</span>
                    <span class="box-result-field-value">
                      {{ student.regStudentId }}
                    </span>
                  </div>
                  <div>
                    <span class="box-result-field-label mr-1">Estatus:</span>
                    <span class="box-result-field-value">
                      {{ student.status }}
                    </span>
                  </div>
                </div>
                <div v-else class="box-result-empty w-40">
                  No se encontró un estudiante con los criterios de búsqueda
                  entrados.
                </div>
              </div>
              <div
                v-if="student"
                class="col-12 col-md d-flex justify-content-center justify-content-md-end align-items-end"
              >
                <ActionButton
                  id="action-btn"
                  class="mr-3"
                  variant="outline-danger"
                  i="fas fa-times-circle"
                  text="Cancelar"
                  @click="cancel"
                />
                <ActionButton
                  id="action-btn"
                  :disabled="!student"
                  text="Añadir"
                  variant="success"
                  i="fas fa-file-plus"
                  @click="addStudent"
                />
              </div>
              <div
                v-else
                class="col-12 col-md d-flex justify-content-end align-items-end"
              >
                <ActionButton
                  id="action-btn"
                  class="mr-3"
                  variant="outline-danger"
                  i="fas fa-times-circle"
                  text="Cancelar"
                  @click="cancel(true)"
                />
                <ActionButton
                  class="full-width-btn"
                  text="Buscar"
                  variant="success"
                  i="fa fa-search"
                  @click="handleSubmit(doSearch)"
                />
              </div>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PageHeader from "PageHeader";
import ActionButton from "ActionButton";
import CustomInput from "CustomInput";
import CustomBalloon from "custom-balloon";
import alertMixin from "@quisit/mipe-utils/mixins/alert.mixin.js";
import transitionStudentService from "@/services/pei/transitionStudent.js";

const ROUTE_NAME = "transition-student-saee-12";

export default {
  name: "AddStudent",
  mixins: [alertMixin],
  components: {
    ActionButton,
    CustomInput,
    CustomBalloon,
    PageHeader
  },
  data() {
    return {
      page: {
        icon: "fas fa-user-edit",
        title:
          "Certificación de Destrezas Académicas, Funcionales y Ocupacionales",
        routes: [
          "Inicio",
          "PEI",
          "SAEE-12 Certificación de destrezas académicas, funcionales y ocupacionales"
        ]
      },
      studentSie: null,
      student: null,
      searched: false
    };
  },
  methods: {
    async doSearch() {
      try {
        const { data } = await transitionStudentService.getStudent(
          this.studentSie
        );
        this.student = data.studentId ? data : null;
        this.searched = true;
      } catch (ex) {
        this.student = null;
        this.ShowToast("Alerta", ex.response.data.message, "error");
      }
    },
    cancel(toHome = false) {
      this.studentSie = null;
      this.student = null;
      this.searched = false;
      this.$refs.studentSieValidator.reset();
      if (toHome) {
        this.$router.push("/pei/transition-student");
      }
    },
    async addStudent() {
      const { data } = await transitionStudentService
        .saveStudentSAEE12(this.studentSie)
        .catch(error => {
          this.ShowToast("Alerta", error.response.data.message, "error");
        });
      if (data) {
        this.ShowToast("Alerta", "Estudiante agregado con éxito", "success");
        this.$router.push({
          name: ROUTE_NAME,
          params: { id: data }
        });
      }
    }
  },
  computed: {
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    }
  }
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@import "@/assets/scss/variables/_colors.scss";

.box-container {
  border: 5px solid map.get($colors, "gray-9");
  border-radius: 5px;
}
.box-title {
  font: Bold 1.125rem Lato;
}
.border-divider:after {
  content: "";
  position: absolute;
  top: 0px;
  right: 0;
  height: 100%;
  border-right: 1px solid map.get($colors, "gray-4");
}
.box-result-empty {
  width: 50%;
  color: map.get($colors, "gray-3");
  text-align: center;
}
.box-result-field-label {
  color: map.get($colors, "gray-6");
}
.box-result-field-value {
  font-weight: bold;
}
.box-divider {
  background-color: map.get($colors, "gray-9");
}
.box-divider-group:before {
  content: "";
  position: absolute;
  top: 50%;
  right: 0;
  width: 100%;
  border-bottom: 1.5px solid map.get($colors, "gray-2");
}
.box-item-border-bottom:not(:last-child) {
  border-bottom: 5px solid map.get($colors, "gray-9");
}
.delete-btn {
  margin-right: 15px;
}
.callout-expanded-container {
  background-color: map.get($colors, "white");
  border: 5px solid map.get($colors, "gray-9");
  border-radius: 5px;
  padding: 15px 30px;
}
.callout-expanded-item {
  background-color: map.get($colors, "secondary-3");
}
.callout-expanded-item:not(:first-child) {
  margin-top: 10px;
}
::v-deep .balloon-container {
  color: map.get($colors, "black_2") !important;
  background-color: map.get($colors, "gray-2") !important;
  font-weight: bold !important;
  font-size: 16px !important;
}
::v-deep .student-search-alert-error {
  height: 0;
}
::v-deep .balloon-container.dark-gray-bg {
  background-color: map.get($colors, "gray-7") !important;
}
@media (max-width: 765px) {
  ::v-deep .full-width-btn {
    width: 100%;
    margin-top: 15px;
  }
  ::v-deep #action-btn {
    width: 50%;
  }
  ::v-deep .delete-btn {
    margin-right: 0;
  }
  .box-result-empty {
    width: 100%;
  }
  ::v-deep .delete-student-btn {
    width: 100%;
  }
}
</style>
